export default __webpack_public_path__ + "indent-right.png";